<template lang="pug">
  section
    .field.is-grouped
      .control
        a(class="button is-danger" :href="createFinalBookShopUrl()")
          b-icon(pack="fas" custom-class="fa-sm fa-plus")
          span
            | 新規登録
      .control
        button(class="button is-info" @click="isComponentModalActive = true" id="search-button")
          b-icon(pack="fas" custom-class="fa-sm fa-search")
          span
            | 絞り込む
    .field.is-grouped.is-pulled-right
      .control
        button(class="button is-danger is-pulled-right right-button" @click="isComponentModalCsvImportFormActive = true" id="csv-import-button")
          b-icon(pack="fas" custom-class="fa-sm fa-file-import")
          span
            | ランキングCSVインポート
      .control
        button(class="button is-info is-pulled-right right-button" @click="exportCsv" id="csv-export-button")
          b-icon(pack="fas" custom-class="fa-sm fa-file-export")
          span
            | 顧客情報エクスポート

    b-modal(:active.sync="isComponentModalActive" has-modal-card)
      search-modal-form(:formProps.sync="formProps" v-on:on-search="onSearch")
    b-modal(:active.sync="isComponentModalCsvImportFormActive" has-modal-card)
      modal-csv-import-form(@importCsvArray="importCsvArray" :dynamicTyping="false")
    b-table(
      :data="data"
      :loading="loading"
      narrowed
      hoverable
      striped
      icon-pack="fa"
      paginated
      pagination-size="is-small"
      pagination-position="both"
      backend-pagination
      :total="total"
      :current-page="page"
      :per-page="perPage"
      @page-change="onPageChange"

      backend-sorting
      :default-sort-direction="defaultSortOrder"
      :default-sort="[sortField, sortOrder]"
      @sort="onSort"
      @click="onClick"
      class="pointable")
      template(slot-scope="props")
        b-table-column(field="ranking" label="売上げランキング" width="80" sortable)
          | {{ props.row.ranking }}
        b-table-column(field="shop_code" label="共有書店コード" width="80" sortable)
          | {{ props.row.shop_code }}
        b-table-column(field="name" width="200" label="書店名")
          | {{ props.row.name }}
        b-table-column(field="group_name" width="130" label="グループ")
          | {{ props.row.group_name }}
        b-table-column(field="prefecture_name" width="80" label="都道府県")
          | {{ props.row.prefecture_name }}
        b-table-column(field="address" width="330" label="住所")
          | {{ address(props.row.main_address, props.row.sub_address) }}
        b-table-column(field="telephone" width="80" label="電話番号")
          | {{ props.row.telephone }}
    .field.is-grouped
      .control
        a(class="button is-danger" :href="createFinalBookShopUrl()")
          b-icon(pack="fas" custom-class="fa-sm fa-plus")
          span
            | 新規登録
      .control
        button(class="button is-info" @click="isComponentModalActive = true")
          b-icon(pack="fas" custom-class="fa-sm fa-search")
          span
            | 絞り込む
</template>

<script>
 import SearchModalForm from './final_book_shops_search_modal_form'
 import ModalCsvImportForm from './accepting_orders/modal_csv_import_form'
 import Turbolinks from "turbolinks"

 export default {
    name: 'final-book-shops-table',
    data() {
      return {
        data: [],
        total: 0,
        loading: false,
        sortField: 'vote_count',
        sortOrder: 'desc',
        defaultSortOrder: 'desc',
        page: 1,
        perPage: 50,
        isComponentModalActive: false,
        isComponentModalCsvImportFormActive: false,
        book_shop_rankings: {},
        formProps: {
          shop_code_cont: '',
          name_cont: '',
          group_code_cont: '',
          telephone_cont: '',
          prefecture_code_or_prefecture_name_cont: '',
          s: '',
          final_book_shop_agencies_agency_code: '',
          final_book_shop_agencies_agency_shop_code: '',
          final_book_shop_agencies_book_sorting_work_code: ''
        }
      }
    },
    components: { 'search-modal-form': SearchModalForm, 'modal-csv-import-form': ModalCsvImportForm },
    methods: {
      createParams(page, perPage) {
        const params = [
          `page=${page ? page : this.page}`,
          `per_page=${perPage ? perPage : this.perPage}`,
          Object.keys(this.formProps).map((key) => {
            return `q[${key}]=${this.formProps[key]}`
          }).join('&')
        ].join('&')
        return params
      },
      /*
       * Load async data
       */
      loadAsyncData() {
        const params = this.createParams()

        this.loading = true
        this.$http.get(`/api/v1/final_book_shops?${params}`)
            .then(({data}) => {
              this.data = []
              let currentTotal = data.total_results
              if (data.total_results / this.perPage > 1000) {
                currentTotal = this.perPage * 1000
              }
              this.total = currentTotal
              data.final_book_shops.forEach((item) => {
                this.data.push(item)
              })
              this.loading = false
              history.pushState(null, null, `/users/final_book_shops?${params}`)
            })
            .catch((error) => {
              this.data = []
              this.total = 0
              this.loading = false
              throw error
            })
      },
      onSearch(){
        this.onPageChange(1)
      },
      /*
       * Handle page-change event
       */
      onPageChange(page) {
        this.page = page
        this.loadAsyncData()
      },
      /*
       * Handle sort event
       */
      onSort(field, order) {
        this.page = 1
        this.sortField = field
        this.sortOrder = order
        this.formProps.s = `${this.sortField} ${this.sortOrder}`
        this.loadAsyncData()
      },
      onClick(row){
        window.location.href = `/users/final_book_shops/${row.id}`
      },
      createFinalBookShopUrl() {
        return "/users/final_book_shops/new"
      },
      address(main_address, sub_address) {
        let address = main_address
        address += sub_address || ''
        return address ? address : ''
      },
      importCsvArray(csvArray) {
        this.loading = true
        this.book_shop_rankings = csvArray.map(element => ({ ranking: element[0], book_shop_code: element[1] }) )
        this.submitRankingRequest().then(({data})=> {
          if(data.book_shop_rankings.error) {
            this.loading = false
            this.$toast.open({
              message: `CSVのインポートに失敗しました。${data.book_shop_rankings.error}`,
              type: 'is-danger',
              position: 'is-bottom'
            })
          } else {
            this.loadAsyncData()
            this.loading = false
            this.$toast.open({
              message: 'CSVのインポートに成功しました。',
              type: 'is-danger',
              position: 'is-bottom'
            })
          }
        })
        .catch((error) => {
          this.loading = false
          throw error
        })
      },
      submitRankingRequest() {
        let method = 'post'
        let url = `/api/v1/book_shop_rankings.json`
        let params = {
          book_shop_rankings: this.book_shop_rankings
        }
        return this.$http({ method: method, url: url, data: params })
      },
      exportCsv() {
        this.loading = true
        const perPage = 999999
        const page = 1
        this.$http.get(`/api/v1/final_book_shops?${this.createParams(page, perPage)}`)
          .then(({data}) => {
            let csv = '\ufeff' + '売上ランキング,共有書店コード,書店名,グループ,都道府県,住所,副住所,電話番号,閉店区分\n'

            data.final_book_shops.forEach(final_book_shop => {
              csv += [
                final_book_shop['ranking'],
                final_book_shop['shop_code'],
                final_book_shop['name'],
                final_book_shop['group_name'],
                final_book_shop['prefecture_name'],
                final_book_shop['main_address'],
                final_book_shop['sub_address'],
                final_book_shop['telephone'],
                final_book_shop['closed_classification']
              ].join(',') + '\n'
            })

            this.loading = false

            let blob = new Blob([csv], { type: 'text/csv' })
            let link = document.createElement('a')
            link.href = window.URL.createObjectURL(blob)
            link.download = 'BookShops.csv'
            link.click()
          })
          .catch((error) => {
            this.loading = false
            this.$toast.open({
              message: 'CSVエクスポートに失敗しました。',
              type: 'is-danger',
              position: 'is-bottom'
            })
            throw error
          })
      }
    },
    filters: {
      /**
       * Filter to truncate string, accepts a length parameter
       */
      truncate(value, length) {
        return value.length > length
            ? value.substr(0, length) + '...'
            : value
      }
    },
    mounted() {
      let queries = this.$qs.parse(location.search.slice(1))

      if(queries) {
        let q = queries.q
        if(q) {
          Object.keys(this.formProps).forEach((key) => {
                if (q[key]) {
                  this.formProps[key] = `${q[key]}`
                }
              }
          )
        }
        if (queries.page)
          this.page = parseInt(queries.page)
      }
      this.loadAsyncData()
    }
  }
</script>

<style scoped>
.right-button {
  margin-top: -45px;
}
</style>